import { IContactNestedDto } from "../../contact/Contact.model"
import { IAttachment, IAttachmentStatus } from "../../media/Media.model"

export interface IATask {
  task: ITaskDto | undefined
  media: ITaskMediaDto[]
}

export interface ITask {
  objectType: string
  createdAt: string
  createdBy: string
  updatedAt: string
  updatedBy: string
  organizationId: string
  ticketId: string
  id: string
  sequence: string
  statusCode: TaskStatus
  status: string
  typeCode: string
  type: string
  title: string
  description?: string
  startedAt?: string
  startingTime?: number
  assignedAt?: string
  assignedTo?: IContactNestedDto
  assignationTime?: number
  arrivalAddress?: string
  arrivedAt?: string
  arrivalTime?: number
  resolution?: string
  resolvedAt?: string
  resolutionTime?: number
  totalAttachments?: number
  totalReports?: number
  totalStorage?: number
}

export interface ITaskDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  ticketId: string
  id: string
  sequence: string
  statusCode: TaskStatus
  status: string
  typeCode: string
  type: string
  title: string
  description?: string
  startedAt?: string
  startingTime?: number
  diagnostic?: string
  assignedAt?: string
  assignedTo?: IContactNestedDto
  assignationTime?: number
  arrivalAddress?: string
  arrivedAt?: string
  arrivalTime?: number
  resolution?: string
  resolvedAt?: string
  resolutionTime?: number
  totalAttachments?: number
  totalReports?: number
  totalStorage?: number
}

export interface ITaskCreateRequestDto {
  createdAt?: string
  createdBy?: string
  organizationId?: string
  ticketId: string
  statusCode: string
  status: string
  typeCode: string
  type: string
  title: string
  description?: string
  diagnostic?: string
  resolution?: string
  assignedTo?: string
  attachments?: IAttachment[]
}

export interface ITaskUpdateRequestDto {
  updatedBy?: string
  updatedAt?: string
  organizationId?: string
  id?: string
  statusCode: string
  status: string
  typeCode: string
  type: string
  title: string
  assignedTo?: string
  description?: string
  diagnostic?: string
  arrivalAddress?: string
  arrivedAt?: string
  resolution?: string
  resolvedAt?: string
  attachments?: IAttachment[]
}

export interface ITaskMedia {
  objectType: string
  createdBy: string
  createdAt: string
  updatedBy: string
  updatedAt: string
  organizationId: string
  ticketId: string
  id: string
  fileId: string
  fileName: string
  temporalPath: string
  path: string
  size: number
  contentType: string
  comments?: string
  status: IAttachmentStatus
  url: string
}

export interface ITaskMediaDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  ticketId: string
  id: string
  fileId: string
  fileName: string
  temporalPath: string
  path: string
  size: number
  contentType: string
  comments?: string
  status: IAttachmentStatus
  url: string
}

export interface ITaskMediaCreateRequestDto {
  createdBy: string
  createdAt: string
  organizationId: string
  ticketId: string
  fileId: string
  fileName: string
  temporalPath: string
  path: string
  size: number
  contentType: string
  comments?: string
  sftp?: boolean
  sftpPath?: string
}

export interface ITicketMediaDeleteRequestDto {
  ticketId: string
  id: string
}

export interface ITaskMediaDeleteRequestDto {
  taskId: string
  id: string
}

export enum TaskType {
  INCIDENT = 'INCIDENT',
  INSTALLATION = 'INSTALLATION',
  OTHER = 'OTHER',
}

export enum TaskStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  RESOLVED = 'RESOLVED',
}

export const getStatusTypes = (status: TaskStatus): TaskStatus[] => {
  switch (status) {
    case TaskStatus.NEW:
      return [TaskStatus.IN_PROGRESS, TaskStatus.ON_HOLD]
    case TaskStatus.IN_PROGRESS:
      return [TaskStatus.ON_HOLD, TaskStatus.RESOLVED]
    case TaskStatus.ON_HOLD:
      return [TaskStatus.IN_PROGRESS, TaskStatus.RESOLVED]
    case TaskStatus.RESOLVED:
      return [TaskStatus.IN_PROGRESS, TaskStatus.ON_HOLD]
    default:
      return [TaskStatus.IN_PROGRESS, TaskStatus.ON_HOLD]
  }
}